// TEMPORARY - DELETE BEFORE MERGE, together with src/utils/cacheBustProbe.ts.
// Side-effect import only: ballast to make the built bundle differ in size and
// content hash while cache-busting is being developed.
import '@/utils/cacheBustProbe';
import { CheckoutProvider } from '@/contexts/checkoutContext';
import { UserProvider } from '@/contexts/userContext';
import { PageDataProvider } from '@/contexts/pageContext';
import { SearchDataProvider } from '@/contexts/searchContext';
import { ShippingProvider } from '@/contexts/shippingContext';
import { ValidationProvider } from '@/contexts/validationContext';
import { ApplePayProvider } from '@/contexts/applePayContext';
import { BasketApp } from './BasketApp';
import { CategoryApp } from './CategoryApp';
import { CheckoutApp } from './CheckoutApp';
import { ProductApp } from './ProductApp';
import { SearchApp } from './SearchApp';
import { SiteApp } from './SiteApp';
import { MyAccountApp } from './MyAccountApp';

const basketRoot = document.getElementById('basketRoot');
const checkoutRoot = document.getElementById('checkoutRoot');
const productRoot = document.getElementById('productRoot');
const categoryRoot = document.getElementById('categoryRoot');
const searchRoot = document.getElementById('searchRoot');
const myAccountRoot = document.getElementById('myAccountRoot');
const siteRoot = document.getElementById('siteRoot');

const root = basketRoot ?? checkoutRoot ?? productRoot ?? categoryRoot ?? searchRoot ?? myAccountRoot ?? siteRoot;

const component = () => {
    if (basketRoot) {
        return (
            <ApplePayProvider>
                <PageDataProvider>
                    <UserProvider>
                        <CheckoutProvider>
                            <ShippingProvider>
                                <BasketApp />
                            </ShippingProvider>
                        </CheckoutProvider>
                    </UserProvider>
                </PageDataProvider>
            </ApplePayProvider>
        );
    }

    if (checkoutRoot) {
        return (
            <ApplePayProvider>
                <PageDataProvider>
                    <UserProvider>
                        <CheckoutProvider isCheckoutPage={true}>
                            <ShippingProvider isCheckoutPage={true}>
                                <ValidationProvider>
                                    <CheckoutApp />
                                </ValidationProvider>
                            </ShippingProvider>
                        </CheckoutProvider>
                    </UserProvider>
                </PageDataProvider>
            </ApplePayProvider>
        );
    }

    if (productRoot) {
        return (
            <ApplePayProvider>
                <PageDataProvider>
                    <ProductApp />
                </PageDataProvider>
            </ApplePayProvider>
        );
    }

    if (categoryRoot) {
        return (
            <PageDataProvider>
                <CategoryApp />
            </PageDataProvider>
        );
    }

    if (searchRoot) {
        return (
            <PageDataProvider>
                <SearchDataProvider>
                    <SearchApp />
                </SearchDataProvider>
            </PageDataProvider>
        );
    }

    if (myAccountRoot) {
        return (
            <PageDataProvider>
                <MyAccountApp />
            </PageDataProvider>
        );
    }

    if (siteRoot) {
        return (
            <PageDataProvider>
                <SiteApp />
            </PageDataProvider>
        );
    }

    return null;
};

export const app = {
    component,
    root,
};
